import { emitAuthTelemetry } from "./authTelemetry";
import { hasAuthGenerationAdvanced, readAuthSnapshot, toRefreshResponse } from "./authState";

export const AUTH_REFRESH_LOCK_NAME = "flymeta.auth.refresh";

function hasWebLocks() {
    return typeof navigator !== "undefined" && navigator.locks && typeof navigator.locks.request === "function";
}

function reuseUpdatedGeneration(beforeSnapshot, entrypoint, correlationId) {
    const latestSnapshot = readAuthSnapshot();
    if (!hasAuthGenerationAdvanced(beforeSnapshot, latestSnapshot)) {
        return null;
    }

    const reused = toRefreshResponse(latestSnapshot);
    if (!reused?.access_token) {
        return null;
    }

    emitAuthTelemetry({
        correlationId,
        entrypoint,
        stage: "lock",
        outcome: "success",
        category: "reused_generation",
    });
    return reused;
}

export async function runWithBrowserRefreshLock(refreshOperation, options = {}) {
    const beforeSnapshot = options.beforeSnapshot || readAuthSnapshot();
    const entrypoint = options.entrypoint || "unknown";
    const correlationId = options.correlationId;

    const executeInsideCriticalSection = async () => {
        const reused = reuseUpdatedGeneration(beforeSnapshot, entrypoint, correlationId);
        if (reused) {
            return reused;
        }
        return refreshOperation(readAuthSnapshot());
    };

    if (!hasWebLocks()) {
        emitAuthTelemetry({
            correlationId,
            entrypoint,
            stage: "lock",
            outcome: "degraded",
            category: "web_locks_unavailable",
        });
        return executeInsideCriticalSection();
    }

    emitAuthTelemetry({
        correlationId,
        entrypoint,
        stage: "lock",
        outcome: "start",
    });

    return navigator.locks.request(AUTH_REFRESH_LOCK_NAME, { mode: "exclusive" }, executeInsideCriticalSection);
}

// Backward-compatible no-op queue API. Refresh queuing now lives in authRefreshOrchestrator.
export function acquireRefresh() {
    return null;
}

export function onRefreshSuccess() {}

export function onRefreshFailure() {}
